declare var NDEFReader: any;

interface NfcData {
  serialNumber;
  message: {
    records?: [{
      id: null, recordType: string, mediaType: string, encoding: string
      data: any,
    }],
  };
}

const scanNfc = (abortController: AbortController): Promise<NfcData> => {
  return new Promise((resolve, reject) => {
    try {
      const reader = new NDEFReader();
      reader.scan({ signal: abortController.signal });
      reader.addEventListener("reading", (e) => resolve(e));
      reader.addEventListener("readingerror", (e) => {
        reject(e);
      });
    } catch (e) {
      reject(e);
    }
  });
};

const readNfcData = (nfcData: NfcData) => {
  if (!nfcData || !nfcData.message) {
    throw new Error(("No records found in NDEF Message"));
  }
  // tslint:disable-next-line:no-console
  console.log(nfcData);
  const records = [];
  nfcData.message.records.forEach((record) => {
    const { id, recordType, mediaType, encoding, data } = record;
    let dataDecoded = data;
    let error = null;
    try {
      const decoder = encoding ? new TextDecoder(encoding) : new TextDecoder();
      dataDecoded = decoder.decode(data);
      if (recordType === "mime" && mediaType === "application/json") {
        dataDecoded = JSON.parse(decoder.decode(data));
      }
    } catch (e) {
      error = e;
    }
    records.push({
      serialNumber : nfcData.serialNumber,
      id,
      recordType,
      mediaType,
      encoding,
      data: dataDecoded,
      error,
    });
  });
  return {
    records,
  };
};

const writeNfcData = async (data: any, recordType, mediaType, abortController: AbortController) => {
  const encoder = new TextEncoder();
  const records = [];
  if (recordType === "mime" && mediaType === "application/json") {
    data = encoder.encode(JSON.stringify(data));
  } else {
    data = encoder.encode(data);
  }
  records.push({ recordType, mediaType, data });
  const reader = new NDEFReader();
  reader.scan({ signal: abortController.signal });
  await reader.write({ records }, { overwrite: true });
  setTimeout(() => abortController.abort(), 5000);
};

export { scanNfc, readNfcData, writeNfcData };
